module.exports = __webpack_public_path__ + "static/img/shoga_rui.7c4a346.jpg";